export default __webpack_public_path__ + "static/media/logo.06c9b225.jpg";